﻿(function ($, document) {
    function ShowLoggedOut() {
        window.location.reload(true);
    }

    $(document).ready(function () {

        if (typeof customerNo == 'undefined') {
            return;
        }

        setInterval(function () {

            $.ajax({
                url: '/api/user/amiloggedin',
                data: JSON.stringify({
                    customerNo: customerNo
                }),
                method: 'POST',
                contentType: "application/json"
            }).done(function (result) {
                if (!result) {
                    ShowLoggedOut();
                }
            }).error(function (result) {
                ShowLoggedOut();
            });
        }, 2 * 60 * 1000);
    });
})(jQuery, document);